<template>
    <v-app class="blog-page">
        <v-container class="blog-list" style="">
            <v-layout d-flex wrap xs12>
                <v-flex xs12 sm6 md4 lg3 d-flex>
                    <h1>Статьи</h1>
                </v-flex>
                <v-flex xs12 sm6 md3 d-flex class="selector-block">
                    <v-menu
                        offset-y
                        :position-x="0"
                        :position-y="0"
                        transition="slide-y-transition"
                        bottom
                        :close-on-content-click="false"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="white"
                                light
                                v-on="on"
                                :class="'p-0'"
                            >
                                <span>{{ selectorText }}</span>
                                <span class="pl-5"><img :src="'/svg/select.svg'"/></span>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile
                                v-for="(item, index) in items"
                                :key="index"
                                @click="checkCategory(item.id)"
                            >
                                <v-list-tile-title
                                    :class="activeCategories.includes(item.id) ? 'active pl-3' : 'pl-3'"
                                >{{ item.name }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                        <v-btn
                            color="primary"
                            dark
                            @click="changeCategory"
                        >
                            Показать
                        </v-btn>
                    </v-menu>
                </v-flex>
                <v-flex d-flex xs12 sm12 md12 lg6 class="categories-list-block" v-if="activeShowCategories.length">
                    <div v-for="item in activeShowCategories" :key="item.id">
                        {{ item.name }}
                        <a @click="removeCategory(item.id)">
                            <img :src="'/svg/cross.svg'"/>
                        </a>
                    </div>
                </v-flex>
            </v-layout>

            <v-layout
                v-show="!articles.data.length"
            >
                <h2>Статей не найдено</h2>
            </v-layout>

            <v-layout
                v-show="articles.data.length"
                v-for="(article, index) in articles.data" :key="'article' + article.id"
                class="row wrap blog-list-article"
            >
                <v-flex class="xs12 md6 blog-list-article-image-block" v-if="article.img">
                    <img :src="getImageUrl(article.img)"
                         class="blog-list-article-image"
                         alt="img"
                         loading="eager"
                         fetchpriority="high"
                    >
                </v-flex>
                <v-flex class="xs12 md6 blog-list-article-content">
                    <h3>{{ article.name }}</h3>
                    <p v-html="getTextPreview(article.text)"></p>
                    <a :href="getPermalink(article.id)" class="blog-button">Читать статью</a>
                </v-flex>
            </v-layout>

            <Pagination
                :pages="pages"
                :category="category"
            />

        </v-container>
    </v-app>
</template>
<script>
    import Pagination from './Pagination'

    export default {
        props: ['articles', 'categories', 'category', 'pages'],
        components: {
            Pagination
        },

        data: () => ({
            items: [],
            defaultSelected: {},
            activeCategories: [],
            activeShowCategories: [],
            selectorText: 'Все статьи'
        }),

        mounted () {
            this.items = [...this.categories.map((item) => { return { id:item.id, name: item.name} })]
            this.activeCategories = Array.from(this.category, item => item.id)
            this.activeShowCategories = this.category
            this.setSelectorText()
        },

        created: () => {

        },

        methods: {
            setSelectorText() {
                if(this.activeShowCategories.length == 1) {
                    this.selectorText = 'Выбрана 1 тема'
                } else if(this.activeShowCategories.length >= 2 && this.activeShowCategories.length < 5) {
                    this.selectorText = `Выбрано ${this.activeShowCategories.length} темы`
                } else if(this.activeShowCategories.length >= 5) {
                    this.selectorText = `Выбрано ${this.activeShowCategories.length} тем`
                }
            },
            getTextPreview(text) {
                let result = this.strippedContent(text)
                if(result.length <= 200){
                    return result
                }
                let lastSpace = result.substr(0, 200).lastIndexOf(" ")
                result = result.substr(0, lastSpace)
                if(result.substr(-1) == '.')
                    return result + '..'
                else
                    return result + '...'
            },
            getPermalink(id) {
                return `/blog/article/${id}`
            },
            strippedContent(text) {
                let regex = /(<([^>]+)>)/ig;
                return text.replace(regex, "");
            },

            checkCategory(id){
                let isset = this.activeCategories.find((item) => {
                    if(item == id){
                        return true
                    }
                    return false
                })
                if(isset){
                    this.activeCategories = this.activeCategories.filter(function(item) {
                        return item !== id
                    })
                }
                else{
                    this.activeCategories.push(id)
                }
            },

            changeCategory() {
                if(this.activeCategories.length){
                    window.location.replace(`${window.location.origin}/blog/?categories=${this.activeCategories.join(',')}`)
                }
                else {
                    window.location.replace(`${window.location.origin}/blog`)
                }
            },
            removeCategory(id){
                this.checkCategory(id)
                this.changeCategory()
            },
            getImageUrl(img) {
                return window.location.origin + '/' + img
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/blog/Blog.vue